import { render, staticRenderFns } from "./LayoutContentRendererDefault.vue?vue&type=template&id=509b0162&scoped=true"
import script from "./LayoutContentRendererDefault.vue?vue&type=script&lang=js"
export * from "./LayoutContentRendererDefault.vue?vue&type=script&lang=js"
import style0 from "./LayoutContentRendererDefault.vue?vue&type=style&index=0&id=509b0162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509b0162",
  null
  
)

export default component.exports